__turbopack_context__.v({
  "chatBubble": "ChatBubble-module__eRACuG__chatBubble",
  "chatBubbleAI": "ChatBubble-module__eRACuG__chatBubbleAI",
  "chatBubbleActive": "ChatBubble-module__eRACuG__chatBubbleActive",
  "chatBubbleMe": "ChatBubble-module__eRACuG__chatBubbleMe",
  "chatBubbleUnread": "ChatBubble-module__eRACuG__chatBubbleUnread",
  "chatBubble__content": "ChatBubble-module__eRACuG__chatBubble__content",
  "chatBubble__content__message": "ChatBubble-module__eRACuG__chatBubble__content__message",
  "chatBubble__threadButtons": "ChatBubble-module__eRACuG__chatBubble__threadButtons",
  "chatBubble__unreadCount": "ChatBubble-module__eRACuG__chatBubble__unreadCount",
  "sc-chat-bubble__firm": "ChatBubble-module__eRACuG__sc-chat-bubble__firm",
  "sc-chat-bubble__header": "ChatBubble-module__eRACuG__sc-chat-bubble__header",
});
